import {
    fetchActivesAndUsedCategories,
    fetchCategories,
    fetchCategory,
    fetchInternalCategories,
    fetchMultipleCategories,
    fetchReapproCategories,
    fetchReapproCategoryAlgorithms,
} from '../queries/categories.queries';

import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';

export const useCategories = () => {
    return useQuery({
        queryKey: ['categories'],
        queryFn: fetchCategories,
    });
};

const internalCategoriesOptions = queryOptions({
    queryKey: ['internalCategories'],
    queryFn: fetchInternalCategories,
});

export const useInternalCategories = () => {
    return useQuery(internalCategoriesOptions);
};

export const useInternalCategory = (id: number) => {
    return useQuery({
        ...internalCategoriesOptions,
        select: (data) => data.find((category) => category.id === id),
        enabled: !Number.isNaN(id),
    });
};

const reapproCategoriesOptions = queryOptions({
    queryKey: ['reapproCategories'],
    queryFn: fetchReapproCategories,
});

export const useReapproCategories = () => {
    return useQuery(reapproCategoriesOptions);
};

export const useReapproCategory = (id: number) => {
    return useQuery({
        ...reapproCategoriesOptions,
        select: (data) => data.find((category) => category.id === id),
        enabled: !Number.isNaN(id),
    });
};

const reapproCategoryAlgorithmsOptions = queryOptions({
    queryKey: ['reapproCategoryAlgorithms'],
    queryFn: fetchReapproCategoryAlgorithms,
});

export const useReapproCategoryAlgorithms = () => {
    return useQuery(reapproCategoryAlgorithmsOptions);
};

export const useActivesAndUsedCategories = (storeId: number) => {
    return useQuery({
        queryKey: ['activesAndUsedCategories', storeId],
        queryFn:
            Number.isNaN(storeId) || storeId === 0
                ? skipToken
                : () => fetchActivesAndUsedCategories(storeId),
    });
};

export const useCategory = (id: number) => {
    return useQuery({
        queryKey: ['category', id],
        queryFn: Number.isNaN(id) || id === 0 ? skipToken : () => fetchCategory(id),
    });
};

export const useMultipleCategories = (ids: number[]) => {
    return useQuery({
        queryKey: ['multipleCategories', ids],
        queryFn: () => {
            if (ids.length === 0) return [];
            return fetchMultipleCategories(ids);
        },
    });
};
